// extracted by mini-css-extract-plugin
export default {"details":"styles_details__3r0+C","btn":"styles_btn__IH4v4"};